module.exports = "/images/people.svg?3a2b59adeeccb55efe3bbfb121a693b5";